import React, { Component} from 'react';
import '../styles/textContentView.scss';
var ReactCSSTransitionGroup = require('react-addons-css-transition-group');
import Citation from '../models/Citation'
import StringHelper from '../utils/stringHelper'
import TextParser from '../models/TextParser'
import CitationComponent from './CitationComponent'

class TextComponent extends Component {
  constructor() {
    super();
    this.state = {shownCitation: null};
  }

  componentWillMount() {

  }

  handleReferenceClicked(citation, event) {
    this.setState({shownCitation: citation});
  }

  citationComponentDidCancel(citationComponent) {
    this.setState({shownCitation: null});
  }

  displayText() {
    let blocks = TextParser.TextBlocksFromText(this.props.text);
    let divs = [];
    for (var i=0;i<blocks.length;i++) {
      let block = blocks[i];
      var d = null;
      if (block.citation != null) {
        d = <span className="reference" key={i} onClick={this.handleReferenceClicked.bind(this, block.citation)}>{block.citation.linkText()}</span>
      }
      else {
        d = <span key={i} dangerouslySetInnerHTML={{__html:block.text}}/>
      }
      divs.push(d);
    }
    return divs;
  }

  render() {
    return (
      <div className={"root"}>
        <div className="textContentBody">
          {this.props.navigation.navBar()}
          <div className="textContentContainer">
            <div className="textContentText">
              <div className="textTopGradient"/>
            {this.displayText()}
              </div>
            </div>
          </div>
        <ReactCSSTransitionGroup transitionName="citation" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
          {this.state.shownCitation != null ? <CitationComponent citation={this.state.shownCitation} delegate={this}/> : null}
        </ReactCSSTransitionGroup>
        </div>
    );
  }

}

export default TextComponent;



/** WEBPACK FOOTER **
 ** ./src/components/TextComponent.js
 **/